<template>
  <div>
  
  
  
   <!-- start company info header -->
  
  <div style="margin-bottom: 90px;background-color: #fff;color: #000;padding: 15px 30px;text-align:center;cursor:pointer;
  				" @click="goToEntity()">
 	<div style="">
 		<div style="padding-bottom:10px;">
   		<div style="font-size: 29px; text-transform: uppercase;font-family:georgia;"> {{coy.entity_name}}</div>
   		<div> <span>UEN: &nbsp;   </span> {{coy.uen}}</div>
   		</div>
    </div>
  </div>
  
  <!-- end company info header -->
  
  
  		 
         <div style="text-align:right; margin-top:90px;">
			 <p-button type="info"  @click="goToEntityDocuments()" >
			  <i slot="label" class="nc-icon nc-settings-gear-65"></i> 
					  Document Browser
					  </p-button>      
		  </div>
        
       
       
       <div style="">
       <h5 style="">Folder: <span style="font-weight:bold;">{{folder.folder_name}} </span></h5>
  		</div>
  		
  		
  		<div style="width:100%;clear:both;margin-bottom:120px;" >
  		<div v-for="tag in tags" style="float:left;margin-right:50px;"  >
          	
				<!--	<p-checkbox  @click="refreshFolder()" style="margin-bottom:15px;margin-top:15px;" :id="tag.id" :value="tag.id" 
					 v-model="selectedTags['t'+tag.id]">
						<span  style="color:#000">{{tag.tag_name}}</span>
					 </p-checkbox>-->
					 
					 <!--
					 <input type="checkbox"  @change="refreshFolder()" style="margin-bottom:15px;margin-top:15px;" :id="tag.id" :value="tag.id"  :name="tag.id" 
					 v-model="selectedTags['t'+tag.id]" /> 
					   <label :for="tag.id"  style="color:#000;margin-left:5px;cursor:pointer;"> {{tag.tag_name}}</label>
					   -->
					 
					 <label class="container_cb">{{tag.tag_name}}
 						 <input type="checkbox"  @change="refreshFolder()" style="margin-bottom:15px;margin-top:15px;" :id="tag.id" :value="tag.id"  :name="tag.id" 
					 v-model="selectedTags['t'+tag.id]"/>
					    <span class="checkmark"></span>
					</label>
					 
					 
					 
		</div>
		</div>		  
  		
  		
  		<div v-if="has_key_docs" class="card" style="margin-bottom:50px; clear:both;">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="key_docs">
            	  <el-table-column label="Title"  property="type_name" sortable></el-table-column>
          		 
          		 
          		 
                <el-table-column label="Uploaded" property="created_at_str" sortable></el-table-column>
                 <el-table-column label="Remarks" property="notes"></el-table-column>
                    <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon  @click="viewDocument(scope.row.document_id)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
        <!-- end card -->

        <div class="card" style="margin-bottom:50px">
          <div class="card-body table-responsive table-full-width">
            <el-table :data="docs">
                <el-table-column label="Title" sortable  property="document_name"  width="500"></el-table-column>
                <el-table-column label="Uploaded" property="created_at_str" sortable></el-table-column>
                 <el-table-column label="Remarks" property="notes"></el-table-column>
    			
    			  <el-table-column label="Task Status" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.task">
           					 <span v-if="scope.row.task.task_status===1">Pending</span>
           					 <span v-if="scope.row.task.task_status===2">Waiting For Signature</span>
           					 <span v-if="scope.row.task.task_status===3">Signed</span>
           					 <span v-if="scope.row.task.task_status===4">Completed/Filed With ACRA</span>
           					 <span v-if="scope.row.task.task_status===5">Cancaelled</span>
           				 </div>
          			</template>
          		 </el-table-column>
          		 
          		
          	    			
                    <el-table-column label="" width="90">
            		<template slot-scope="scope">
            			 <p-button type="success" size="sm" icon @click="viewDocument(scope.row.id)">
                 			 <i class="fa fa-edit"></i>
                		</p-button>
					</template>
               </el-table-column>
                 
            </el-table>

          </div>
        </div>
        <!-- end card -->
        
        
        
        
        
	       
	       
        
  
    </div>
</template>
<script>
  import {DatePicker, TimeSelect, Slider, Tag, Input, Button, Select, Option} from 'element-ui'
  import {Collapse, CollapseItem, Tabs, TabPane, Card} from 'src/components/UIComponents'
  import ApiService from 'src/services/api.service'
  import swal from 'sweetalert2'
  
  
  
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [TimeSelect.name]: TimeSelect,
      [Slider.name]: Slider,
      [Tag.name]: Tag,
      [Input.name]: Input,
      [Button.name]: Button,
      [Option.name]: Option,
      [Select.name]: Select,
      TabPane,
      Tabs,
      CollapseItem,
      Collapse,
      Card
    },
    
     mounted() {

      	this.loadFolder();
    },
    
     
    data () {
      return {
        coy:[],
        docs:[],
        key_docs:[],
        folders:[],
        folder:{},
        tags:[],
        initTags:0,
        selectedTags:[],
        selectedTagsArr:[],
        has_key_docs: false,
    	eid: this.$route.params.eid,
		 new_mail: {
          document_name: '',
          notes:'',
        },
        modelValidations: {
          title: {
          },
          description: {
          },
          amount: {
            required: true,
            decimal:true,
          },
          due_date: {
          	required: true,
          },
         
          
        },
      }
    },
    methods:{
      refreshFolder(){
      	this.loadFolder();
      },
      goToEntity(){
	  	 this.$router.push( '/view-entity/'+this.coy.id);
	    },
	    loadFolder(){
	    	swal.showLoading();
	    	
	    	let vm = this;
	    	
	    	vm.selectedTagsArr = [];
			
			var tags_1 = this.tags;
			tags_1.forEach(function(t){
				if(vm.selectedTags["t"+t.id]==true){
					vm.selectedTagsArr.push(t.id);
					
				}
			});
			
			
	    	
	    	
	    	let uri = this.$base_url+'/api/v1/documents/get_folder_documents/'+this.$route.params.dfid+'/entity/'+ this.$route.params.eid;
			
			
			
			ApiService.post(uri,{
				      			'selected_tags': vm.selectedTagsArr,
			
			}).then(response => {
				this.coy = response.data.entity;
				this.docs = response.data.documents;
				this.key_docs = response.data.key_documents;
				this.folder = response.data.folder;
				if(response.data.key_documents.length>0){
					this.has_key_docs = true;
				}
				
				//for tags
				if(this.initTags == 0){
					this.tags = response.data.tags;
					let vm = this;
					response.data.tags.forEach(function(tag){
							if(tag){
									vm.selectedTags["t"+tag.id] = false;
							 }
					 });
				 
					 this.initTags = 1;
				 }
				swal.close();	
			})
			
			
			
	    },
	    viewDocument(did){
	    	this.$router.push( '/view-document/'+did+"/1");
	    
	    },
	    viewFolder(eid, dfid){
	    	this.$router.push( '/view-folder/'+dfid+"/entity/"+eid);
	    },
	    goToEntityDocuments(){
      		 this.$router.push( '/entity-documents/'+this.$route.params.eid)  
       },
	   
      
    },

    
  }
</script>
<style>
  .extended-forms .el-select {
    width: 100%;
  }
  
  .el-date-editor .el-input__inner{
  	padding-left:36px!important;
  }
  
  
   /* Customize the label (the container) */
.container_cb {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container_cb input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #999;
}

/* On mouse-over, add a grey background color */
.container_cb:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.container_cb input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container_cb input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container_cb .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
} 
</style>


